module.exports = __webpack_public_path__ + "images/emoji/clock630.26b1998bcaee753346b9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock630.png
// module id = yRk6
// module chunks = 1